import React from 'react';

import './ManageUser.css';
import Modal from '../../../components/UI/Modal/Modal';
import FormGrid from '../../../components/UI/FormGrid/FormGrid';
import Textbox from '../../../components/UI/Textbox/Textbox';
import Select from '../../../components/UI/Select/Select';
import {locationlist} from '../../../shared/constants';
import Button from '../../UI/Button/Button';

const locationlists = Object.keys(locationlist).map((location) => {
  return <option >{location}</option>
});


/**
* @desc Add and update recruiter(Modal)
* @version 0.1.0
* @author Jamshith
*/

const ManageUser = (props) => {
  return(
    <Modal show={props.showAddUsermodal ||props.showupdateUserModal} className="add-recruiter-modal" backdropClassName="manage-user-backdrop">
      <div className="add-recruiter-modal-header">{props.showAddUsermodal?"Add User":"Update User"}</div>
        <div className="add-recruiter-modal-sub-header">Personal Details</div>
          <FormGrid grid="auto auto auto">
            <Textbox 
              id="firstName" 
              className={(props.errorPosition.includes("firstName")) ?"invalid-input":""}
              label="First Name:" 
              placeholder="Enter First Name" 
              value={props.recruiterDetails.firstName} 
              onChange={(event) => props.handleRecruiterDetailsChange(event)}
              >
              <p className="error-message">{(props.errorPosition.includes("firstName")) ? "Please enter First Name" : null}</p>          
            </Textbox>
            <Textbox 
              id="lastName" 
              className={(props.errorPosition.includes("lastName")) ? "invalid-input" :"" }
              label="Last Name:" 
              placeholder="Enter Last Name" 
              value={props.recruiterDetails.lastName} 
              onChange={(event) => props.handleRecruiterDetailsChange(event)}
              > 
              <p className="error-message">{(props.errorPosition.includes("lastName")) ? "Please enter Last Name" : null}</p>
            </Textbox>
            <Textbox 
              id="userBhId" 
              className={props.errorPosition.includes("userBhId")? "invalid-input" : ""}
              label="Bullhorn ID:" 
              placeholder="Enter Bullhorn ID" 
              value={props.recruiterDetails.userBhId} 
              onChange={(event) => props.handleRecruiterDetailsChange(event)}
              onKeyPress={props.handleKeyPressBullhornIdChange}
              onPaste ={(event)=>props.handlePasteChange(event)}
              > 
              <p className="error-message">{(props.errorPosition.includes("userBhId")) ? "Please enter valid BullhornId" :props.errorPosition.includes('BHIDExists')?"User Bullhorn ID already exists":null}</p>
            </Textbox>
            <Textbox 
              id="email" 
              className={(props.errorPosition.includes("contactEmailEmpty")) ? "invalid-input" : 
                (props.errorPosition.includes("contactEmailFormat")) ?"invalid-input" : ""}
              label="Email:" 
              placeholder="Enter Email" 
              disabled={props.showupdateUserModal?true:false}
              value={props.recruiterDetails.email} 
              onChange={(event) => props.handleRecruiterDetailsChange(event)}
              > 
              <p className="error-message">{(props.errorPosition.includes("contactEmailEmpty")) ? "Please enter Email" :
              props.errorPosition.includes("contactEmailFormat") ? "Please enter a valid Email" :
              props.errorPosition.includes("UserExists")?"User already exists":props.errorPosition.includes("UserNotExists")? "User not exists" : ""}</p>
            </Textbox>
            <Select 
              id="location" 
              className={(props.errorPosition.includes("location"))? "invalid-input" : ""}
              label="Location:" 
              value={props.recruiterDetails.location} onChange={(event) => props.handleRecruiterDetailsChange(event)}
              error= {(props.errorPosition.includes("location")) ? "Please select a valid  location" : null}>
              <option value="">Select</option>
              {locationlists}
            </Select>
            
        </FormGrid>
        {props.showAddUsermodal?
        <div className="generate-password-wrapper">
          <div className="generate-password">Generated Password will be sent to the user email ID</div>
        </div>:
        <div className="pass-reset"></div>}
      <div className="add-recruiter-modal-footer">
        <Button uistyle="lesser"onClick={props.handleCancelAddRecruiter}>Cancel</Button>
        <Button onClick={props.submitRecruiterDetails} disabled={props.disableUpdateButton}>{props.showAddUsermodal?"Add":"Update"}</Button>
      </div>
    </Modal>
  );
}

export default ManageUser;


// WEBPACK FOOTER //
// ./src/components/Admin/ManageUser/ManageUser.js